import React from 'react';

import { FlatTableCell, FlatTableRow, FlatTableRowHeader } from 'carbon-react/lib/components/flat-table';

import { DragHandle, useTreeRow } from '@futrli/ui-components';

import { DriverDragHandlers } from '../../hooks/useDriversDragDrop/useDriversDragDrop';
import { DriverRowActions } from './driver-row-actions';
import { DriverRowName } from './driver-row-name';
import { formatDriverValue } from './utils';
import { NonFinancialDriverTreeNode } from '../../types';

interface Props {
  row: NonFinancialDriverTreeNode;
  columns: string[];
  isNested?: boolean;
  isReordering?: boolean;
  isUpdating?: boolean;
  drag: DriverDragHandlers;
  index: number;
}

export const DriverRow = ({ row, columns, isNested, isReordering, isUpdating, drag, index }: Props) => {
  const { rowRef, indentPx } = useTreeRow({
    depth: row.depth || 0,
    drag,
    index,
    isReordering: !!isReordering,
    type: row.type
  });

  return (
    <FlatTableRow
      bgColor={isNested ? '#F4F5F6' : undefined}
      key={row.id}
      ref={rowRef}
      data-element={isUpdating ? 'updating-driver-row' : undefined}
    >
      {isReordering ? (
        <FlatTableRowHeader width={300} pl={`${indentPx}px`}>
          <div style={{ display: 'flex', alignItems: 'center', height: '20px' }}>
            <DragHandle drag={drag} index={index} rowRef={rowRef} useFirstColumnDragImage />
            <DriverRowName name={row.name} isExcelDriver={row.is_excel_driver} withDragOffset />
          </div>
        </FlatTableRowHeader>
      ) : (
        <FlatTableRowHeader width={300} pl={`${indentPx}px`}>
          <DriverRowName name={row.name} isExcelDriver={row.is_excel_driver} />
        </FlatTableRowHeader>
      )}
      {columns.map(column => (
        <FlatTableCell key={column} width={120}>
          {formatDriverValue(row.values[column], row.decimalDisplay)}
        </FlatTableCell>
      ))}
      <FlatTableCell width={150}>
        <DriverRowActions row={row} drag={drag} index={index} />
      </FlatTableCell>
    </FlatTableRow>
  );
};
